import React, { useState, useEffect } from "react";
import axios from "axios";
import { ReactSession } from "react-client-session";
import moment from "jalali-moment";
import BaaHam_NormalUsers_AgahiBox from "../BaaHam_NormalUsers_AgahiBox";
import "./BaaHam_NormalUsers_AgahihayeMan.css";
import "../BaaHam_NormalUsers_AgahiBox.css";
import Image1 from "../../../../pic1.jpg";
import { BsShare } from "react-icons/bs";

function BaaHam_NormalUsers_AgahihayeMan() {
    const [userAgahi, setUserAgahi] = React.useState([]);
    useEffect(() => {
        axios
            .get("https://hammaskan.ir:8443/api/advertises/user", {
                params: {
                    userId: "6268d5152e15cfab05130eb7",
                    perPage: 20,
                    page: 0,
                    sort: -1,
                },
            })
            .then((res) => {
                console.log(res);
                setUserAgahi(res.data.data);
            })
            .catch((error) => {
                // console.log(error);
            });
    }, []);

    function deleteAgahi(agahiId) {
        console.log(agahiId);
        var agahiDialogWait = document.getElementById("agahiDialogWait");
        var agahiDialogOk = document.getElementById("agahiDialogOk");
        var agahiDialogErr = document.getElementById("agahiDialogErr");

        agahiDialogWait.style.display = "inline-block";
        agahiDialogOk.style.display = "none";
        agahiDialogErr.style.display = "none";
        axios
            .delete("https://hammaskan.ir:8443/api/advertises/" + agahiId)
            .then((res) => {
                console.log(res);
                agahiDialogWait.style.display = "none";
                agahiDialogOk.style.display = "inline-block";
                agahiDialogErr.style.display = "none";

                axios
                    .get("https://hammaskan.ir:8443/api/advertises/user", {
                        params: {
                            userId: "6268d5152e15cfab05130eb7",
                            perPage: 20,
                            page: 0,
                            sort: -1,
                        },
                    })
                    .then((res) => {
                        console.log(res);
                        setUserAgahi(res.data.data);
                    })
                    .catch((error) => {
                        // console.log(error);
                    });
            })
            .catch((error) => {
                // console.log(error);
                agahiDialogWait.style.display = "none";
                agahiDialogOk.style.display = "none";
                agahiDialogErr.style.display = "inline-block";
                if (error.response.data.message) {
                    agahiDialogErr.textContent = error.response.data.message;
                } else {
                    agahiDialogErr.textContent = "امکان ارسال پیامک وجود ندارد";
                }
            });
    }
    return (
        <div className="BaaHam_NormalUsers_AgahihayeMan">
            <div className="labelLSGN" id="agahiDialogWait" style={{ display: "none", fontSize: "14px", backgroundColor: "#1B9CFC", color: "snow", width: "100%", padding: "12px 0", borderRadius: "6px", margin: "12px 0" }}>
                لطفا کمی صبر کنید ...
            </div>
            <div className="labelLSGN" id="agahiDialogOk" style={{ display: "none", fontSize: "14px", backgroundColor: "#06d6a0", color: "snow", width: "100%", padding: "12px 0", borderRadius: "6px", margin: "12px 0" }}>
                آگهی مورد نظر حذف شد
            </div>
            <div className="labelLSGN" id="agahiDialogErr" style={{ display: "none", fontSize: "14px", backgroundColor: "tomato", color: "snow", width: "100%", padding: "12px 0", borderRadius: "6px", margin: "12px 0" }}>
                --
            </div>
            {userAgahi.length !== 0 ? (
                <div>
                    {userAgahi.map(function (item, i) {
                        return (
                            <div className="BaaHam_NormalUsers_AgahiBox">
                                <div className="BaaHam_NormalUsers_AgahiBoxImageContainer">
                                    {item.image[0] ? <img alt="hi2" src={"https://hammaskan.ir:8443/api/data/image/?imagePath=" + item.image[0].link} className="BaaHam_NormalUsers_AgahiBoxImage" /> : <img src={Image1} className="BaaHam_NormalUsers_AgahiBoxImage" />}
                                </div>
                                <div className="BaaHam_NormalUsers_AgahiBoxContent">
                                    <span className="BaaHam_NU_AgahiBoxContentTitle">{item.title}</span>
                                    <span className="BaaHam_NU_AgahiBoxContentNumber">{item.description}</span>
                                    <div className="BaaHam_NU_AgahiBoxContentEditDelete">
                                        <span className="BaaHam_NU_AgahiBoxContentEdit" style={{ backgroundColor: "#1B9CFC", color: "snow", padding: "6px 12px", borderRadius: "6px", cursor: "pointer" }}>
                                            ویرایش
                                        </span>
                                        <span className="BaaHam_NU_AgahiBoxContentDelete" onClick={() => deleteAgahi(item.id)} style={{ backgroundColor: "#FC427B", color: "snow", padding: "6px 12px", borderRadius: "6px", cursor: "pointer" }}>
                                            حذف
                                        </span>
                                    </div>
                                    <div className="BaaHam_NU_AgahiBoxFooter">
                                        <div className="BaaHam_NU_AgahiBoxFooterDateTime">
                                            <span className="BaaHam_NU_AgahiBoxFooterDate">تاریخ:</span>
                                            <span className="BaaHam_NU_AgahiBoxFooterTime">{moment(item.updatedAt).locale("fa").format("YYYY/MM/DD HH:MM")}</span>
                                        </div>
                                        {/* <div className="BaaHam_NU_AgahiBoxFooterIconContainer">
                                            <div className="BaaHam_NU_AgahiBoxFooterIcon">
                                                <BsShare />
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div style={{ width: "100%", backgroundColor: "tomato", color: "snow", textAlign: "center", fontSize: "12px", borderRadius: "6px" }}>
                    <p style={{ width: "100%", textAlign: "center", paddingRight: "24px" }}>هیچ آگهی تاکنون ثبت نشده است</p>
                </div>
            )}
        </div>
    );
}

export default BaaHam_NormalUsers_AgahihayeMan;
